export interface StripeDonation {
  amount: number;
  cardCvc: string;
  cardExpirationMonth: number;
  cardExpirationYear: number;
  cardNumber: string;
  currency: string;
  donorEmail: string;
  donorLastName: string;
  donorFirstName: string;
  postalCode: string;
  donationFrequency: string;
}
